import { Text, TextProps } from '@shopify/polaris';
import { memo } from 'react';
type RegularTextProps = Partial<TextProps>;
const RegularText = ({ as = 'span', variant = 'bodyMd', ...props }: RegularTextProps) => {
  return (
    <Text as={as} variant={variant} {...props}>
      {props.children}
    </Text>
  );
};
export default memo(RegularText);
